import React from 'react';
import TodoEntry from "../TodoEntry";
import UpdatableCard from "./UpdatableCard";
import Omnibar from "../Omnibar";
import {getTodoText} from "../../helpers/helpers";
import {fetchList, submitListEntry} from "../../api/listApiHandler";
import {btnoptions, ButtonList} from "../ui/ButtonList";
import {useMutation, useQuery, useQueryClient} from "react-query";
import {useMediaQuery} from "../../hooks/useMediaQuery";

function CheckListCard(props) {

    const isMobile = useMediaQuery('(max-width: 767px)');
    const queryClient = useQueryClient()
    const list = useQuery(['list', props.listid], () => fetchList(props.listid))
    const mutateList = useMutation({
        mutationFn: submitListEntry,
        onSuccess: () => {
            queryClient.invalidateQueries(['list', props.listid])
        }
    })

    if (!list.isSuccess) {
        return "Loading..."
    }

    let listHTML = list.data.map((item, index) =>
        <TodoEntry hiddenProps={(item) => ({listid: item.listid})} key={index} item={item}
                   options={[btnoptions.CHECK_OFF_LISTITEM, btnoptions.DELETE]} getText={getTodoText}/>
    );

    return (
        <UpdatableCard title={props.title} empty={false} isDropdown={isMobile}
                       buttons={<ButtonList item={props.listid} options={[/*btnoptions.DELETE_LIST*/]}/>}>
            <ul style={{
                listStyle: "none",
                paddingInline: 0
            }}>
                {listHTML}
                {
                    props.editable ?
                        <Omnibar onSubmit={(entry, _item, _showTooltip) =>
                            mutateList.mutate({listid: props.listid, entry: entry})
                        }
                                 onValidate={() => {
                                 }}
                                 placeholder={"Add item ..."} resizeable={true}/> : ""
                }
            </ul>
        </UpdatableCard>
    );
}

export default CheckListCard;